import useInterval from "hooks/useInterval"
import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
} from "reactstrap"

export const IdleTimeOutModal = ({
  showModal,
  handleContinue,
  handleLogout,
}) => {
  const [logoutInterval, setLogoutInterval] = useState(100)
  const [interval, setInterval] = useState(null)

  const intervalRef = useInterval(() => {
    if (logoutInterval === 0) {
      handleLogout()
    } else {
      setLogoutInterval(old => old - 1)
    }
  }, interval)

  return (
    <Modal
      isOpen={showModal}
      onOpened={() => {
        setInterval(100)
      }}
      onClosed={() => {
        window.clearInterval(intervalRef)
        setInterval(null)
        handleContinue()
        setLogoutInterval(100)
      }}
      centered
    >
      <ModalHeader>
        Você está inativo por muito tempo!
        <button
          type="button"
          onClick={() => {
            window.clearInterval(intervalRef)
            setInterval(null)
            handleContinue()
            setLogoutInterval(100)
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            Sua sessão será desativada devido inatividade. Deseja continuar?
          </Col>
        </Row>
        <Row>
          <Col>
            {`Você será automaticamente desconectado em: ${
              logoutInterval / 10
            }s.`}
            <Progress
              color="warning"
              value={logoutInterval}
              animated
            ></Progress>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {
            window.clearInterval(intervalRef)
            setInterval(null)
            handleLogout()
            setLogoutInterval(100)
          }}
        >
          Logout
        </Button>
        <Button
          color="primary"
          onClick={() => {
            window.clearInterval(intervalRef)
            setInterval(null)
            handleContinue()
            setLogoutInterval(100)
          }}
        >
          Continuar Sessão
        </Button>
      </ModalFooter>
    </Modal>
  )
}
